// extracted by mini-css-extract-plugin
export default {"root":"UploadersList__root--Bz_Wv"};